import script from "./InstructionConnectiveOnePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionConnectiveOnePage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionConnectiveOnePage.vue?vue&type=style&index=0&id=c8eab3c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8eab3c8"]])

export default __exports__